import { useRouteMatch, useLocation } from 'react-router-dom';
import { PATHS } from 'src/common/constants';
import { SidebarContextRow } from '../Components/SidebarContextTree';

interface RouteParams {
  id: string;
}

interface KeyContactLocationState {
  keyContact?: {
    id: string;
    name: string;
  };
}

const useKeyContactContextRows = (): SidebarContextRow[] | null => {
  const match = useRouteMatch<RouteParams>({ path: PATHS.KEY_CONTACTS_VIEW });
  const location = useLocation<KeyContactLocationState>();

  const keyContactId: string = match?.params?.id ?? '';

  if (!match || !keyContactId) {
    return null;
  }

  // legacy/workaround: a single key contact has no fetch-by-id endpoint — the
  // detail page is handed the whole record through router state, so the label
  // comes from there too. On hard refresh that state is gone (the detail page
  // itself renders blank), so we show no tree rather than an empty row.
  const keyContact = location.state?.keyContact;

  if (!keyContact) {
    return null;
  }

  return [
    {
      label: keyContact.name ?? '',
      path: PATHS.KEY_CONTACTS_VIEW.replace(':id', keyContactId),
      icon: 'user',
    },
  ];
};

export default useKeyContactContextRows;
